import type { FC } from 'react';

import { ErrorState } from '../error-state/error-state';

type WarningMessageBoxProps = {
  headerText?: string;
  bodyText: string;
  buttonText?: string;
  onClick?: () => void;
  to?: string;
  href?: string;
};

export const WarningMessageBox: FC<WarningMessageBoxProps> = ({
  headerText,
  bodyText,
  buttonText,
  onClick,
  to,
  href,
}) => (
  <ErrorState
    headlineCopyKey={headerText}
    textCopyKey={bodyText}
    customButton
    buttonProps={{
      copyKey: buttonText,
      onClick,
      to,
      href,
    }}
  />
);
